export default "__VITE_ASSET__hjK97WAL__"